
import { defineComponent, PropType } from 'vue'
import { toSentenceCase } from '~/utils/string'

export default defineComponent({
  name: 'CustomizeWidgetsModalRow',
  layout: 'dashboard',
  model: {
    prop: 'value',
    event: 'input'
  },
  emits: ['input'],
  props: {
    value: {
      type: Array as PropType<string[]>,
      required: true
    },
    draggable: {
      type: Boolean,
      default: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    widgetName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  methods: {
    toSentenceCase,
    updateRowCheck(): void {
      if (this.value.includes(this.widgetName)) {
        this.$emit(
          'input',
          this.value.filter((val) => val !== this.widgetName)
        )
      } else {
        this.$emit('input', [...this.value, this.widgetName])
      }
    }
  },
  computed: {
    modelValue: {
      get(): string[] {
        return this.value
      },
      set(value: string[]): void {
        this.$emit('input', value)
      }
    }
  }
})
